/* eslint-disable no-bitwise */

export function hashCode(value?: string | null): number {
  let hash = 0;
  if (!value || value.length === 0) {
    return hash;
  }
  for (let i = 0; i < value.length; i++) {
    const char = value.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
}
